<rk-fold-item [name]="nameHeader">
  <ng-container [formGroup]="numericItemForm">
    <mat-radio-group rkInput formControlName="operator">
      <mat-radio-button value="none">{{ allText }}</mat-radio-button>
      <ng-container *ngIf="!skipEqual">
        <mat-radio-button value="equals">{{ equalText }}</mat-radio-button>
        <div
          [@slideInOutBlock]
          *ngIf="numericItemForm.get('operator').value === 'equals'"
        >
          <rk-form-field [hintRight]="labelNumberInput">
            <input
              type="number"
              formControlName="equalInput"
              rkInput
              pKeyFilter="int"
              inputType="num"
              min="0"
            />
          </rk-form-field>
        </div>
      </ng-container>
      <ng-container *ngIf="!skipNotEquals">
        <mat-radio-button value="not_equals">{{ notEqualText }}</mat-radio-button>
        <div
          [@slideInOutBlock]
          *ngIf="numericItemForm.get('operator').value === 'not_equals'"
        >
          <rk-form-field [hintRight]="labelNumberInput">
            <input
              type="number"
              formControlName="notEqualInput"
              rkInput
              pKeyFilter="int"
              inputType="num"
              min="0"
            />
          </rk-form-field>
        </div>
      </ng-container>
      <mat-radio-button value="lower">{{ lowerText }}</mat-radio-button>
      <div [@slideInOutBlock] *ngIf="numericItemForm.get('operator').value === 'lower'">
        <rk-form-field [hintRight]="labelNumberInput">
          <input
            type="number"
            formControlName="lessInput"
            rkInput
            pKeyFilter="int"
            inputType="num"
            min="0"
          />
        </rk-form-field>
      </div>
      <mat-radio-button value="greater">{{ greaterText }}</mat-radio-button>
      <div [@slideInOutBlock] *ngIf="numericItemForm.get('operator').value === 'greater'">
        <rk-form-field [hintRight]="labelNumberInput">
          <input
            type="number"
            formControlName="overInput"
            rkInput
            pKeyFilter="int"
            inputType="num"
            min="0"
          />
        </rk-form-field>
      </div>
      <mat-radio-button value="between">{{ betweenText }}</mat-radio-button>
      <div [@slideInOutBlock] *ngIf="numericItemForm.get('operator').value === 'between'">
        <div class="group">
          <rk-form-field>
            <input
              type="number"
              formControlName="betweenLessInput"
              rkInput
              pKeyFilter="int"
              inputType="num"
              min="0"
            />
          </rk-form-field>
          <span> {{ 'MEDIA.FILTERS.NUMERIC_INPUT.AND' | translate }} </span>
          <rk-form-field [hintRight]="labelNumberInput">
            <input
              type="number"
              formControlName="betweenMoreInput"
              rkInput
              pKeyFilter="int"
              inputType="num"
              min="0"
            />
          </rk-form-field>
        </div>
      </div>
      <mat-radio-button *ngIf="!skipNotSet" value="not_set">{{
        notSetText
      }}</mat-radio-button>
    </mat-radio-group>
  </ng-container>
</rk-fold-item>
